export default "__VITE_ASSET__4vmmMaZJ__"